"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const StringUtils_1 = tslib_1.__importDefault(require("../util/StringUtils"));
class NumericFirstAlphaSecondComparator {
    compareTo(s1, s2) {
        return this.compare(s1, 0, s2, 0);
    }
    compare(s1, offset1, s2, offset2) {
        let i1 = this.getNumericPrefix(s1, offset1);
        let i2 = this.getNumericPrefix(s2, offset2);
        if (i1 === offset1 && i2 === offset2) {
            // No numeric prefix found
            i1 = this.getNonNumericPrefix(s1, offset1);
            i2 = this.getNonNumericPrefix(s2, offset2);
            const lexCompare = s1.substring(offset1, i1).localeCompare(s2.substring(offset2, i2));
            if (lexCompare !== 0) {
                return lexCompare;
            }
        }
        else if (i1 !== offset1 && i2 !== offset2) {
            const prefix1 = this.parseFloat(s1.substring(offset1, i1));
            const prefix2 = this.parseFloat(s2.substring(offset2, i2));
            if (prefix1 > prefix2) {
                return 1;
            }
            else if (prefix1 < prefix2) {
                return -1;
            }
        }
        else if (i1 !== offset1) {
            // Only s1 has a numeric prefix and we want numbers before letters
            return -1;
        }
        else {
            // Only s2 has a numeric prefix
            return 1;
        }
        // two equal non-numeric prefixes found
        if (i1 === s1.length && i2 === s2.length) {
            return 0;
        }
        else if (i1 === s1.length) {
            // s1 is shorter than s2 but equal up to the length of s2..
            return 1;
        }
        else if (i2 === s2.length) {
            // s2 is shorter than s1 but equal up to the length of s1..
            return -1;
        }
        return this.compare(s1, i1, s2, i2);
    }
    parseFloat(s) {
        return parseFloat(s.replace(",", "."));
    }
    getNumericPrefix(s, offset) {
        let i;
        let c = "0";
        let decimalSeparatorSeen = false;
        for (i = offset; i < s.length; i++) {
            c = s.charAt(i);
            if (!(StringUtils_1.default.onlyContainsDigits(c) || (i > offset && (c === "." || c === ",")))) {
                break;
            }
            if (c === "." || c === ",") {
                if (decimalSeparatorSeen) {
                    break;
                }
                else {
                    decimalSeparatorSeen = true;
                }
            }
        }
        while (i > offset && (c === "." || c === ",")) {
            // Decimal separator cannot be the last character of a number, so back off
            i--;
        }
        return i;
    }
    getNonNumericPrefix(s, offset) {
        let i;
        for (i = offset; i < s.length; i++) {
            let c = s.charAt(i);
            if (StringUtils_1.default.onlyContainsDigits(c) || (i > offset && (c === "." || c === ","))) {
                break;
            }
        }
        return i;
    }
}
exports.default = NumericFirstAlphaSecondComparator;
//# sourceMappingURL=NumericFirstAlphaSecondComparator.js.map